import { csrfHeader } from '~/utils/csrf'
import { encodeAsJSON } from '~/utils/json'

const exportHeaders = {
  csv: { 'Content-Type': 'application/json', Accept: 'text/csv' },
}

function filenameFromHeader(contentDisposition) {
  if (!contentDisposition) return 'download.csv'
  const match = contentDisposition.match(/filename="?([^"]+)"?/)
  return match?.[1] || 'download.csv'
}

export async function handleExport(url, params, format) {
  let response
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: { ...(exportHeaders[format] || {}), ...csrfHeader() },
      body: encodeAsJSON(params),
    })
  } catch (error) {
    console.error('Error exporting data:', error)
    return { ok: false, error }
  }

  if (!response.ok) {
    const error = new Error(`Export failed: ${response.status}`)
    console.error('Error exporting data:', error)
    return { ok: false, error }
  }

  const filename = filenameFromHeader(response.headers.get('Content-Disposition'))
  const blob = await response.blob()
  const downloadUrl = window.URL.createObjectURL(blob)
  try {
    const a = document.createElement('a')
    a.href = downloadUrl
    a.download = filename
    // Safari requires the anchor to be in the document for the download to trigger.
    document.body.appendChild(a)
    a.click()
    a.remove()
  } finally {
    window.URL.revokeObjectURL(downloadUrl)
  }
  return { ok: true, filename }
}
